// extracted by mini-css-extract-plugin
module.exports = {"moreMarkets":"MoreMarkets_moreMarkets__30g4T","moreMarketsBtn":"MoreMarkets_moreMarketsBtn__3vdka"};